module.exports = __webpack_public_path__ + "media/images/icons/filled/code-sandbox-circle-a0e2068158d857fd342c24fc5ce05e3f.svg";